import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthProvider, pdfDataAdapter, Loader } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import PdfViewer from "@cloudpremise/portal_core/src/themes/mui/components/PdfViewer";

// @mui material components
import Grid from "@mui/material/Grid";

declare const window: Window & typeof globalThis & {
    inlineApexAdaptor: any,
    pdfjsLib: any,
    PDFViewerApplication: any,
    getViewerConfiguration: any
}

const PdfFiles = (props) => {
    const [ authorized ] = useAuthProvider();
    const [state, setState] = React.useState({
        firstName: "",
        lastName: "",
        email: "",
        company: "",
        isSuccess: false,
        loading: false,
        errorMessage: null,
        pdfModal: false,
        pdfData: null
    });
    const navigate = useNavigate();
    React.useEffect(() => {
        if(!authorized){
            return navigate("/home", { replace: true });
        }
    });
    function loadPdf(){
        pdfDataAdapter((data) => {
            setState({
                ...state,
                loading: false,
                pdfModal: true,
                pdfData: data
            });
        });
        setState({
            ...state,
            loading: true,
        });
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                <MDBox mb={2}>
                    <MDButton key="save" variant="gradient" color="info" onClick={(e) => loadPdf()}>
                        {
                            state.loading ?
                                <Loader color="white" size={20} />
                            :
                            "Load Pdf"
                        }
                    </MDButton>
                </MDBox>

                {
                    state.pdfModal ?
                        <PdfViewer
                            open={state.pdfModal}
                            width="1024px"
                            maxWidth="none"
                            onClose={() => setState({...state, pdfModal: false})}
                            title="Pdf Viewer"
                            data={state.pdfData}
                        />
                    :
                    null
                }
            </MDBox>
        </DashboardLayout>
    )
}

export default PdfFiles;